export interface ProgressVerse {
  surahNumber: number
  ayahNumber: number
}

export interface ProgressCredit extends ProgressVerse {
  durationSec: number
}

/**
 * onAyahChange fires for the ayah that just STARTED. Listening time in
 * lastAyahDurationRef belongs to the ayah that just FINISHED. Credit the
 * previous verse, or skip when this is the first play of a session.
 */
export function progressCreditOnAyahChange(
  previous: ProgressVerse | null,
  _started: ProgressVerse,
  durationSec: number,
): ProgressCredit | null {
  if (!previous) return null
  return {
    surahNumber: previous.surahNumber,
    ayahNumber: previous.ayahNumber,
    durationSec: Math.max(0, durationSec),
  }
}

